<template>
  <a href="~@img/Zoom_Getting Started with PC and MAC v6.pdf" download="ZOOM" class='downLoad'>ZOOM</a>
</template>
<script>
export default {
  props:{
    isCheck:{
      default:false,
      required:false
    }
  }



}
</script>
<style lang='less'>
.downLoad{
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  width:75px;
  height:75px;
  text-align: center;
  padding-top:52px;
  background: url('~@img/donwload_icons.png') no-repeat center 10px;
  box-shadow:0 0 2px 2px #ecebec ;
  border-radius: 5px;
  &.mypage_icon{
    background-image: url('~@img/mypage_icons.png');
  }
  &:hover{
    border:1px solid #fcc800;
  }
}
</style>


// WEBPACK FOOTER //
// zoom.vue?1713fd8a